"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_array_1 = require("../arrays/is-array");
/**
 * Determine if the given value is an object. Arrays are not considered objects.
 *
 * @Param {any} value - The value to check if it's an object.
 *
 * @Example
 *
 *   isObject({})
 *   //=> true
 *
 *   isObject([])
 *   //=> false
 *
 *   isObject(null)
 *   //=> false
 */
function isObject(value) {
    if (is_array_1.isArray(value)) {
        return false;
    }
    if (value === null) {
        return false;
    }
    return typeof value === 'object';
}
exports.isObject = isObject;
//# sourceMappingURL=is-object.js.map